/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Cancel order request
 */
export interface CancelRequest {
  /**
   * Order ID. If empty - cancel with any ID.
   */
  orderId?: number;
  /**
   * Account ID. If empty - cancel for any account.
   */
  accountId?: number;
  /**
   * Pair ID. If empty - cancel on all pairs.
   */
  pairId?: number;
}
